import api from "@/api/index";
import restfulApi from "@/api/restfulApi";

export default {

  /**
   *
   * @param houseData
   * @returns Promise
   */
  addHouse(houseData) {
    return api.post(restfulApi.getLink('passports', 'POST'), houseData)
  },

  /**
   *
   * @param link
   * @param houseData
   * @returns Promise
   */
  editHouse(link, houseData) {
    return api.put(link, houseData)
  },

  /**
   *
   * @param link
   * @returns Promise
   */
  deleteHouse(link) {
    return api.delete(link)
  },

  /**
   *
   * @returns Promise
   */
  getHousesList(page = 1, page_size) {
    return api.get(restfulApi.getLink('passports', 'GET'), {params: {page, page_size}}).then(response => response.data)
  },

  /**
   *
   * @returns Promise
   */
  getHouseById(id) {
    return api.get(`${restfulApi.getLink('passports', 'GET')}${id}/`).then(response => response.data)
  },

  /**
   *
   * @param search
   * @param page
   * @param page_size
   */
  searchHouses(search, page = 1, page_size = 10) {
    return api.get(restfulApi.getLink('passports', 'GET'), {params: {search, page, page_size}})
      .then(response => response.data)
  },

  /**
   *
   */
  loadAllPassportsCoordinates(search) {
    return api.get(restfulApi.getLink('passports_for_map', 'GET'), {params: {search}})
      .then(response => response.data)
  }
}
